import { Reducer } from 'redux';
import { GET_STATES_AND_PROVINCES_SUCCESS, StatesAndProvincesActionTypes, StatesAndProvincesState } from './types';
import { PARSAction } from 'core';

const initialState: StatesAndProvincesState = {
  statesAndProvinces: [],
};

export const statesAndProvincesReducer: Reducer<StatesAndProvincesState, PARSAction> = (
  state = initialState,
  action: StatesAndProvincesActionTypes,
): StatesAndProvincesState => {
  switch (action.type) {
    case GET_STATES_AND_PROVINCES_SUCCESS:
      return { ...state, statesAndProvinces: action.payload };
    default:
      return { ...state };
  }
};
